<template>
  <div class="login">
    <div class="login__form_wrapper">
      <div class="login__form">
        <img
          class="login__logo"
          src="@/assets/rfx-logo-full.svg"
          alt="AudienceKey"
        >
        <span
          v-if="errorField.length"
          class="login__form_error-message"
        >
          {{ errorField }}
        </span>
        <input
          v-model="data.email"
          type="email"
          :disabled="isDataUpdating"
          class="login__form_input"
          placeholder="Email"
        >
        <base-material-design-icon
          class="login__form_input_icon login__form_input_icon-email"
          icon="email"
        />
        <input
          v-model="data.password"
          type="password"
          :disabled="isDataUpdating"
          class="login__form_input"
          placeholder="Password"
        >
        <base-material-design-icon
          class="login__form_input_icon login__form_input_icon-password"
          icon="password"
        />
        <div class="login__form_forgot-pass-wrapper">
          <base-check-box
            v-model="data.rememberMe"
            class="login__form_remember-me"
            :disabled="isDataUpdating"
            :class="{ 'login__form_remember-me_checked': data.rememberMe }"
            label="Remember me"
          />
          <router-link
            to="/user/forgot-password"
            class="login__form_forgot-password"
          >
            Forgot your Password?
          </router-link>
        </div>
        <button
          :disabled="isDataUpdating"
          class="login__form_submit"
          @click.prevent="onSubmit"
        >
          SIGN IN
        </button>
      </div>
      <!-- <p class="login__register_wrapper">
        Don’t have an account? <router-link
          to="/user/register"
          class="login__register"
        >
          Register!
        </router-link>
      </p> -->
      <p class="login__register_wrapper">Don’t have an account? <a href="https://audiencekey.com/contact/" class="login__register">Contact us!</a></p>
    </div>
    <div class="login__intro">
      <p class="login__intro_header">
        Still not using <br>Audience Key?
      </p>
      <p class="login__intro_content">
        Learn more about how our platform can<br>change the way you conduct your strategic<br>content marketing program.
      </p>
      <a
        href="https://audiencekey.com/"
        class="login__intro_link"
        target="_blank"
      >
        Learn More <span class="login__intro_arrow" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Login',
  props: {
    next: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isDataUpdating: false,
      data: {
        rememberMe: false,
        email: '',
        password: ''
      },
      errorFields: {}
    }
  },
  computed: {
    ...mapState(['applicationRoutes']),
    errorField () {
      return Object.values(this.errorFields)[0] || ''
    },
    isNextAvailable () {
      return !!this.next.length
    }
  },
  mounted () {
    document.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        this.onSubmit()
      }
    })
  },
  beforeDestroy () {
    document.removeEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        this.onSubmit()
      }
    })
  },
  methods: {
    ...mapActions(['getCurrentSession', 'getUserRoles', 'getAgencyModeRoutes']),
    ...mapActions('auth', ['loginUser']),
    async onSubmit () {
      this.isDataUpdating = true
      const response = await this.loginUser(this.data)
      this.errorFields = response.error_fields || {}
      if (response.is_successful) {
        await this.getCurrentSession()
        if (!this.clients.length) {
          this.$router.push({ path: '/setup-wizard' })
          return
        }
        let isNextValid = false
        if (this.next) {
          isNextValid = this.applicationRoutes.some(route => (
            route.regex.test(this.next) && route.allowed && route.name !== 'not-found'
          ))
        }
        let homePage = this.applicationRoutes.find(route => route.name === 'strategy' && route.allowed)?.path
        homePage = homePage || this.applicationRoutes.find(route => route.name === 'Progress' && route.allowed)?.path
        homePage = homePage || '/strategy/url-planner'
        const nextPage = isNextValid ? this.next : homePage
        this.$router.push({ path: nextPage })
        // await this.getUserRoles().then(() => {
        //   this.$router.push({ path: this.isNextAvailable ? this.next : this.isCurrentUserAgent ? '/strategy' : '/reports' })
        //   if (this.isCurrentUserAgent) {
        //     this.getAgencyModeRoutes()
        //   }
        // })
      }
      this.isDataUpdating = false
    }
  }
}
</script>

<style lang="scss" scoped>
 .login {
   width: -webkit-fill-available;
   position: relative;
   display: flex;
   align-items: center;
   justify-content: center;

   &__register {
     color: #fff !important;
     text-decoration: underline;

     &_wrapper {
       margin: 48px 0 0;
       padding: 0;
       color: #fff;
       font-size: 16px;
       line-height: 20px;
     }
   }

   &__form {
     width: 490px;
     background-color: #fff;
     border-radius: 16px;
     box-shadow: 0 6px 16px 0 rgba(96, 97, 112, 0.2), 0 1px 4px 0 rgba(40, 41, 61, 0.06);
     padding: 64px 48px 48px;
     display: flex;
     flex-direction: column;
     align-items: center;

     &_error-message {
       position: absolute;
       top: 138px;
       font-size: 14px;
       color: $rfx-light-red;
     }

     &_wrapper {
       margin-right: 150px;
       display: flex;
       flex-direction: column;
       align-items: center;
     }

     &_submit {
       margin-top: 28px;
       outline: none;
       border: none;
       padding: 16px 59px;
       line-height: 24px;
       font-size: 16px;
       font-weight: bold;
       color: #fff;
       background-color: $rfx-bright-turquoise;
       border-radius: 8px;

       &:disabled {
         pointer-events: none;
         opacity: .4;
       }
     }

     &_remember-me {
        &::v-deep .checkbox__label {
          font-size: 14px;
          color: $rfx-medium-march !important;
        }

       &_checked {
          &::v-deep .checkbox__dummy {
            color: $rfx-bright-turquoise !important;
          }
       }
     }

     &_forgot-pass-wrapper {
       width: -webkit-fill-available;
       display: flex;
       justify-content: space-between;
       margin-top: 24px;
     }

     &_forgot-password {
       font-size: 14px;
       line-height: 20px;
       color: #42b5a5;
       text-decoration: underline;
     }

     &_input {
       width: -webkit-fill-available;
       line-height: 24px;
       border-radius: 8px;
       border: solid 1px #7c8e9b;
       padding: 16px 16px 16px 56px;
       color: $rfx-medium-march !important;
       margin: 1px;

       &:disabled {
         background-color: #7c8e9b40;
       }

       &::placeholder {
        color: $rfx-medium-march;
       }

       &:focus {
         border: 2px solid $rfx-bright-turquoise;
         outline: none;
         margin: 0;
       }

       &_icon {
         font-size: 24px;
         color: $rfx-medium-march;
         width: 0;
         height: 0;
         position: relative;
         left: -230px;

         &-email {
           top: -18px;
           margin-bottom: 24px;
         }

         &-password {
           top: -19px;
         }
       }
     }
   }

   &__logo {
     margin-bottom: 64px;
     width: 68%;
   }

   &__intro {
     // 20px(.login__intro_link height) + 48px(.login__intro_link margin-top) = 68px
     // have been made for centring according .login__form block
     margin-bottom: 68px;
     display: flex;
     flex-direction: column;

     &_header {
       font-size: 40px;
       font-weight: bold;
       color: #fff;
       line-height: 48px;
       padding: 0;
       margin-bottom: 24px;
       margin-top: 0;
     }

     &_content {
       color: #fff;
       font-size: 20px;
       line-height: 28px;
       padding: 0;
       margin-bottom: 40px;
       margin-top: 0;
     }

     &_link {
       color: $rfx-bright-turquoise;
       background-color: #fff;
       padding: 16px 32px;
       font-size: 16px;
       font-weight: bold;
       line-height: 24px;
       width: max-content;
       text-decoration: none;
       border-radius: 18px;
       text-transform: uppercase;
     }

     &_arrow {
       margin-left: 12px;
       padding: 4px;
       border: solid $rfx-bright-turquoise;
       border-width: 0 2px 2px 0;
       display: inline-block;
       transform: rotate(-45deg);
     }
   }
 }

 @media only screen and (max-width: 1090px) and (min-width: 591px) {
   .login {
     &__register_wrapper {
       margin-bottom: 144px !important;
     }

     &__intro_header {
       font-size: 32px;
     }
   }
 }

 @media only screen and (max-width: 1090px) {
   .login {
     flex-direction: column;
     height: 100%;
     justify-content: flex-start;
     margin-top: 40%;

     &__form {
       &_wrapper {
         margin-right: 0;
       }
     }

     &__register_wrapper {
       margin: 32px 0 44px;
     }

     &__intro {
       &_header {
         margin-bottom: 32px;

         br {
           display: none;
         }
       }

       &_content {
         display: none;
       }

       &_link {
         align-self: center;
         padding: 0;
         font-weight: bold;
         background-color: transparent;
         color: #fff;
       }

       &_arrow {
         border-color: #fff;
       }
     }
   }
 }

 @media only screen and (max-width: 590px) {
   .login {
     margin-top: 0;

     &__form {
       padding: 48px 24px 32px;
       border-top-left-radius: 0;
       border-top-right-radius: 0;
       width: -webkit-fill-available;
       position: relative;

       &_wrapper {
         margin-right: 0;
         width: 100%;
       }

       &_forgot-password,
       &_remember-me {
         font-size: 12px;
       }

       &_submit {
         margin-top: 32px;
       }

       &_forgot-pass-wrapper {
         margin-top: 16px;
       }

       &_input {
         &[type=email] {
           margin-bottom: 17px;

           &:focus {
             margin-bottom: 16px;
           }
         }

         &_icon {
           position: absolute;
           left: 43px;

           &-email {
             top: 177px;
           }

           &-password {
             top: 251px;
           }
         }
       }
     }

     &__logo {
       width: 220px;
       margin-bottom: 56px;
     }

     &__register_wrapper {
       font-size: 12px;
       margin-bottom: 46px;
     }

     &__intro {
       padding: 0 30px;
       margin-bottom: 0;
       flex-direction: row;
       justify-content: space-between;
       width: -webkit-fill-available;
       align-items: baseline;

       &_header {
         font-size: 12px;
         font-weight: normal;
         line-height: 16px;
       }

       &_link {
         align-self: auto;
         font-size: 12px;
         font-weight: bold;
       }
     }
   }
 }
</style>
